<template>
  <div style="padding: 16px">
    <shrimp-quality-modal
        :id="`shrimp-quality-modal-${_uid}`"
    ></shrimp-quality-modal>
    <div v-if="(model.ticket || {}).customer_type">
      <div class="row">
        <validation-provider
            v-if="!useDownPaymentProduct"
            v-slot="{ validated, errors }"
            :name="$t('purchase_orders.send_to_rfq')"
            class="col-md-3"
            vid="send_to_rfq"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="$t('purchase_orders.forms.send_to_rfq_question')"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-form-checkbox
                v-model="model.send_to_rfq"
                :unchecked-value="false"
                :value="true"
                name="send_to_rfq"
                stacked
            />
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="$t('purchase_orders.farmer_id')"
            class="col-md-3"
            vid="farmer_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="'Nama Petambak'"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <multiselect-ajax
                :key="`${_uid}-farmers`"
                v-model.number="model.farmer_id"
                :custom-label="farmerLabel"
                :params="{ type: 'farmer', active: 1 }"
                :url="`/customers`"
                name="farmer_id"
                @update:selected="onFarmerSelected($event)"
            >
              <template v-slot:beforeList>
                <b-button v-b-modal="`customer-farmer-create-modal-${_uid}`" variant="link">
                  +
                  {{
                    $t("Add new {something}", {
                      something: $t("purchase_orders.from_farmer"),
                    })
                  }}
                </b-button>
                <customer-create-modal
                    :id="`customer-farmer-create-modal-${_uid}`"
                    :key="
                    `customer-create-modal-${selectedCustomerType}-${model.farmer_id}`
                  "
                    :initial-value="{ type: ['farmer'] }"
                    :modal-title="`BUAT TAMBAK BARU`"
                    @created="
                    (event) => {
                      $set(model, 'farmer_id', event.id);
                      $nextTick(() => {
                        $refs.farm_multiselect.fetchOptions();
                      });
                    }
                  "
                ></customer-create-modal>
              </template>
            </multiselect-ajax>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-if="!useDownPaymentProduct"
            v-slot="{ validated, errors }"
            :name="$t('purchase_orders.vendor_selection')"
            class="col-md-3"
            rules="required"
            vid="vendor_selection"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label="Petambak sebagai Vendor di RFQ?"
              label-cols-md="12"
          >
            <b-form-radio-group
                v-model="model.vendor_selection"
                :disabled="!model.farmer_id"
                :options="vendor_selection_options"
                name="vendor_selection"
                stacked
            />
          </b-form-group>
        </validation-provider>
        <validation-provider v-slot="{ validated, errors }"
            :name="$t('purchase_orders.farm_id')"
            class="col-md-3"
            vid="farm_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="'Nama Tambak'"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <multiselect-ajax
                :key="`${_uid}-farms`"
                ref="farm_multiselect"
                v-model.number="model.farm_id"
                :custom-label="(m) => [m.name, m.region_full_name].join(' - ')"
                :params="{ customer_id: model.farmer_id }"
                :url="`/farms`"
                name="farm_id"
            >
            </multiselect-ajax>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-if="model.shrimp_selected.code !== 'down_payment'"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_orders.hatchery_id'))"
            class="col-md-3"
            vid="hatchery_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.startCase($t('purchase_orders.hatchery_id'))}`"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <manufacture-select-ajax
                :key="`${_uid}-hatchery`"
                ref="hatchery_multiselect"
                v-model.number="model.hatchery_id"
                :params="{ type: 'seed', is_active: 1, or_where_id__in: model.hatchery_id }"
                name="hatchery_id"
            >
            </manufacture-select-ajax>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-if="model.shrimp_selected.code !== 'down_payment'"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_orders.feed'))"
            class="col-md-3"
            rules="max:255"
            vid="feed"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('purchase_orders.feed'))}`"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <multiselect-ajax
                :key="`${_uid}-feed-products`"
                ref="feed_product_multiselect"
                v-model="model.feed_product_ids"
                :custom-label="({name}) => name"
                :params="{ is_active: 1, sort: 'name,asc' }"
                :url="`/v1/feed_products`"
                name="feed_product_ids"
                :multiple="true"
            >
            </multiselect-ajax>
          </b-form-group>
        </validation-provider>
      </div>
      <div class="row">
        <validation-provider
            v-if="model.shrimp_selected.code === 'down_payment'"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_orders.estimated_ordered_at'))"
            :rules="estimatedHarvestRules"
            class="col-md-3"
            vid="estimated_harvest_date"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="
              lodash.upperFirst($t('purchase_orders.estimated_ordered_at')) +
                '*'
            "
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <date-picker
                :state="errors[0] ? false : validated ? true : null"
                :value="model.estimated_harvest_date"
                format="DD MMMM YYYY"
                name="estimated_harvest_date"
                required
                type="date"
                @input="model.estimated_harvest_date = $event"
            >
            </date-picker>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-else
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_orders.ordered_at'))"
            :rules="
            `required|before_or_equal:${this.$moment().format('YYYY-MM-DD')}`
          "
            class="col-md-3"
            vid="ordered_at"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="lodash.upperFirst($t('purchase_orders.ordered_at')) + '*'"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <date-picker
                :state="errors[0] ? false : validated ? true : null"
                :value="model.ordered_at"
                format="DD MMMM YYYY"
                name="ordered_at"
                required
                type="date"
                @input="model.ordered_at = $event"
            >
            </date-picker>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-if="model.ticket.customer_type === 'brs' && model.shrimp_selected.code !== 'down_payment'"
                             v-slot="{ validated, errors }" :name="lodash.upperFirst($t('purchase_orders.top'))"
                             class="col-md-2" rules="required|min_value:0" vid="top">
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('purchase_orders.top'))}*`"
              :state="errors[0] ? false : (validated ? true : null)"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-input-group :append="$t('units.days')">
              <b-form-input
                  id="top"
                  v-model.number="model.duration"
                  :placeholder="lodash.upperFirst($t('purchase_orders.top'))"
                  :state="errors[0] ? false : (validated ? true : null)"
                  name="top"
                  style="text-align: right"
                  type="number"
              />
            </b-input-group>
          </b-form-group>
        </validation-provider>
        <div class="col-md-2">
          <b-form-group
              v-if="model.ticket.customer_type === 'brs' && model.shrimp_selected.code !== 'down_payment'"
              :label="`${lodash.upperFirst($t('due_date'))}*`"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-input-group>
              <b-form-input
                  id="due_date"
                  v-model="dueDate"
                  :placeholder="lodash.upperFirst($t('due_date'))"
                  name="due-date"
                  readonly
                  type="text"
              />
            </b-input-group>
          </b-form-group>
        </div>
      </div>

      <b-form-group
          v-if="model.shrimp_selected.code === 'down_payment'"
          :label="'Dokumen Down Payment (PNG, JPG, PDF)'"
          class="row mb-3"
          content-cols="12"
          content-cols-md="12"
          label-cols-md="12"
      >
        <div key="down_payment_document" class="row g-2">
          <validation-provider
              :key="model.down_payment_document.preview"
              v-slot="{ validated, errors }"
              name="attachment"
              rules="files_mimes:image/jpeg,image/png,application/pdf"
              vid="down_payment_document"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : validated ? true : null"
            >
              <div class="row">
                <div class="col-md-6">
                  <file-drag-and-drop
                      v-model="model.down_payment_documents"
                      :drop-placeholder="lodash.upperFirst($t('drop file here'))"
                      :placeholder="
                      lodash.upperFirst($t('choose a file or drop it here'))
                    "
                      :state="errors[0] ? false : validated ? true : null"
                      accept="image/jpeg,image/png,application/pdf"
                      name="`down_payment_document`"
                  ></file-drag-and-drop>
                </div>
                <div class="col-md-12">
                  <div class="d-flex gap-2">
                    <template
                        v-for="(file, index) in model.down_payment_documents"
                    >
                      <file-item
                          v-if="file"
                          :key="index"
                          :deletable="true"
                          :file="file"
                          @delete="removeFile('down_payment_documents', index)"
                      ></file-item>
                    </template>
                  </div>
                </div>

              </div>
            </b-form-group>
          </validation-provider>
        </div>
      </b-form-group>
      <b-form-group
          v-else
          :label="'Attachment (PNG, JPG, PDF)'"
          class="row mb-3"
          content-cols="12"
          content-cols-md="12"
          label-cols-md="12"
      >
        <div key="invoice_document" class="row g-2">
          <validation-provider
              :key="model.invoice_document.preview"
              v-slot="{ validated, errors }"
              name="attachment"
              vid="invoice_document"
              rules="files_mimes:image/jpeg,image/png,application/pdf"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : validated ? true : null"
            >
              <div class="row">
                <div class="col-md-6">
                  <file-drag-and-drop
                      v-model="model.invoice_documents"
                      :drop-placeholder="lodash.upperFirst($t('drop file here'))"
                      :placeholder="lodash.upperFirst($t('choose a file or drop it here'))"
                      :state="errors[0] ? false : validated ? true : null"
                      accept="image/jpeg,image/png,application/pdf"
                      name="invoice_document"
                  ></file-drag-and-drop>
                </div>
                <div class="col-md-12">
                  <div class="d-flex gap-2">
                    <template
                        v-for="(file, index) in model.invoice_documents"
                    >
                      <file-item
                          v-if="file"
                          :key="index"
                          :deletable="true"
                          :file="file"
                          @delete="removeFile('invoice_documents', index)"
                      ></file-item>
                    </template>
                  </div>
                </div>
              </div>
            </b-form-group>
          </validation-provider>
        </div>
      </b-form-group>
      <validation-provider
          v-if="model.shrimp_selected.code === 'down_payment'"
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('purchase_orders.down_payment'))"
          rules="required|gt:0"
          vid="down_payment"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('purchase_orders.down_payment'))}*`"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <numeral-input
              id="down_payment"
              v-model.number="model.down_payment"
              :disabled="downPaymentDisabledRules"
              :placeholder="'Rp'"
              :state="errors[0] ? false : validated ? true : null"
              format="$ 0,0.[00]"
              lazy-formatter
              name="down_payment"
              @blur="updateLocalStorage"
          />
        </b-form-group>
      </validation-provider>
      <hr v-if="model.ticket.customer_type === 'lcs'"/>
      <div v-if="model.shrimp_selected.code !== 'down_payment'">
        <b-form-group
            :label="`ITEM`"
            class="mb-3"
            label-class="custom-label-form-group"
            label-cols-sm="12"
        >
          <!-- template label -->
          <template #label>
            <div class="d-flex justify-content-between section-label">
              <div class="text-primary">
                {{ lodash.upperCase($t("purchase_orders.purchase_item")) }}
              </div>
              <!-- <div><b-button variant="link-success" @click="addPurchaseItem"><u class="text-success">Tambah item nota panen</u></b-button></div> -->
            </div>
          </template>
          <b-button
              v-b-modal="`shrimp-quality-modal-${_uid}`"
              class="text-success text-decoration-underline px-0"
              tag="span"
              variant="link"
          >
            Pelajari kualitas udang
          </b-button>
          <div v-if="undeletedItems('purchase_items').length">
            <template
                v-for="(purchase_item, key) in undeletedItems('purchase_items')"
            >
              <template v-if="purchase_item._action !== 'delete'">
                <b-form-group v-bind:key="key" class="row mb-3">
                  <div class="row">
                    <validation-provider
                        v-slot="{ validated, errors }"
                        :name="lodash.upperFirst($t('purchase_orders.quality'))"
                        :vid="`purchase_items.${key}.quality`"
                        class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                        rules="required"
                    >
                      <b-form-group
                          :invalid-feedback="errors[0]"
                          :label="
                          `${lodash.startCase($t('purchase_orders.quality'))}*`
                        "
                          :state="errors[0] ? false : validated ? true : null"
                      >
                        <b-form-select
                            id="quality"
                            v-model="purchase_item['quality']"
                            :name="`purchase_items[${key}][quality]`"
                            :options="quality_options"
                            :placeholder="
                            lodash.upperFirst($t('purchase_orders.quality'))
                          "
                            :state="errors[0] ? false : validated ? true : null"
                            @blur="updateLocalStorage"
                        />
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                        v-slot="{ validated, errors }"
                        :name="lodash.upperFirst($t('purchase_orders.doc'))"
                        :vid="`purchase_items.${key}.doc`"
                        class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                        rules="gt:0|integer"
                    >
                      <b-form-group
                          :invalid-feedback="errors[0]"
                          :label="
                          `${lodash.upperFirst(
                            $t('purchase_orders.doc')
                          )} (${$t('Days')})`
                        "
                          :state="errors[0] ? false : validated ? true : null"
                      >
                        <b-input-group>
                          <numeral-input
                              id="doc"
                              v-model="purchase_item['doc']"
                              :name="`purchase_items[${key}][doc]`"
                              :placeholder="
                              `${lodash.upperFirst(
                                $t('purchase_orders.doc')
                              )} (${$t('Days')})`
                            "
                              :state="errors[0] ? false : validated ? true : null"
                              style="text-align: right"
                              @blur="updateLocalStorage"
                          />
                        </b-input-group>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                        v-slot="{ validated, errors }"
                        :name="lodash.upperFirst($t('purchase_orders.biomassa'))"
                        :vid="`purchase_items.${key}.quantity`"
                        class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                        rules="required|gt:0"
                    >
                      <b-form-group
                          :invalid-feedback="errors[0]"
                          :label="
                          `${lodash.upperFirst(
                            $t('purchase_orders.biomassa')
                          )} (${lodash.upperFirst($t('units.kg'))})*`
                        "
                          :state="errors[0] ? false : validated ? true : null"
                      >
                        <b-input-group>
                          <numeral-input
                              id="quantity"
                              v-model="purchase_item['quantity']"
                              :name="`purchase_items[${key}][quantity]`"
                              :placeholder="
                              `${lodash.upperFirst(
                                $t('purchase_orders.biomassa')
                              )} (${lodash.upperFirst($t('units.kg'))})`
                            "
                              format="0,0.[000]"
                              :state="errors[0] ? false : validated ? true : null"
                              style="text-align: right"
                              @input="onChangePurchaseItemQuantity(purchase_item)"
                          />
                        </b-input-group>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                        v-slot="{ validated, errors }"
                        :name="lodash.upperFirst($t('purchase_orders.size'))"
                        :vid="`purchase_items.${key}.size`"
                        class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                        rules="required|min_value:10"
                    >
                      <b-form-group
                          :invalid-feedback="errors[0]"
                          :label="
                          `${lodash.upperFirst($t('purchase_orders.size'))}*`
                        "
                          :state="errors[0] ? false : validated ? true : null"
                      >
                        <b-input-group>
                          <numeral-input
                              id="size"
                              v-model="purchase_item['size']"
                              :name="`purchase_items[${key}][size]`"
                              :placeholder="
                              lodash.upperFirst($t('purchase_orders.size'))
                            "
                              format="0,0.[00]"
                              :state="errors[0] ? false : validated ? true : null"
                              style="text-align: right"
                              @blur="updateLocalStorage"
                          />
                        </b-input-group>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                        v-slot="{ validated, errors }"
                        :name="
                        lodash.upperFirst($t('purchase_orders.unit_price'))
                      "
                        :rules="priceRules"
                        :vid="`purchase_items.${key}.unit_price`"
                        class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                    >
                      <b-form-group
                          :invalid-feedback="errors[0]"
                          :label="
                          `${lodash.upperFirst(
                            $t('purchase_orders.unit_price')
                          )}${isKmService ? '' : '*'}`
                        "
                          :state="errors[0] ? false : validated ? true : null"
                      >
                        <numeral-input
                            id="unit_price"
                            v-model="purchase_item['unit_price']"
                            :name="`purchase_items[${key}][unit_price]`"
                            :placeholder="
                            lodash.upperFirst($t('purchase_orders.unit_price'))
                          "
                            :state="errors[0] ? false : validated ? true : null"
                            format="$ 0,0.[00]"
                            lazy-formatter
                            required
                            style="text-align: right"
                            @input="onChangePurchaseItemUnitPrice(purchase_item)"
                        />
                      </b-form-group>
                    </validation-provider>
                    <b-form-group
                        :label="
                        `${lodash.upperFirst(
                          $t('purchase_orders.total_price')
                        )}${isKmService ? '' : '*'}`
                      "
                        class="col-sm-6 col-md-9 col-lg-8 col-xl-2 mt-2"
                    >
                      <numeral-input
                          id="total_unit_price"
                          :name="`purchase_items[${key}][total_price]`"
                          :placeholder="
                          lodash.upperFirst($t('purchase_orders.total_price'))
                        "
                          :value="
                          purchase_item.quantity * purchase_item.unit_price
                        "
                          disabled
                          format="$ 0,0.[00]"
                          lazy-formatter
                          style="text-align: right"
                          @blur="updateLocalStorage"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
                <div :key="`purchase_items.key.${key}.delete`" class="row g-2">
                  <div class="col-sm delete-item">
                    <div class="float-end">
                      <b-button
                          v-if="undeletedItems('purchase_items').length > 1"
                          class="text-danger text-decoration-underline"
                          style="margin-right: 10px;"
                          tag="span"
                          variant="link"
                          @click="removeItem('purchase_items', key)"
                      >{{ $t("Delete") }}
                      </b-button
                      >
                      <b-button
                          v-if="
                          key === undeletedItems('purchase_items').length - 1
                        "
                          class="text-success text-decoration-underline"
                          tag="span"
                          variant="link"
                          @click="addPurchaseItem"
                      >
                        Tambah item
                      </b-button>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <div v-else class="text-center empty-state">
            Belum ada item nota panen
          </div>
        </b-form-group>
        <hr/>
      </div>
      <span v-if="model.shrimp_selected.code !== 'down_payment'">
        <b-form-group
            :label="lodash.upperCase($t('purchase_orders.additional_fee'))"
            class="row mb-3"
            label-class="text-primary"
            label-cols-md="12"
        >
          <template #label>
            <div class="d-flex justify-content-between section-label">
              <div class="text-primary">
                {{ lodash.upperCase($t("purchase_orders.additional_fee")) }}
              </div>
              <div>
                <b-button v-b-modal="`additional-fee-modal-${_uid}`" variant="link-success"
                ><u class="text-success">Buat biaya tambahan</u></b-button
                >
              </div>
              <purchase-order-additional-item-modal
                  :id="`additional-fee-modal-${_uid}`"
                  modal-title="Buat biaya tambahan"
                  nameLabel="Nama biaya"
                  totalLabel="Total biaya"
                  @ok="($event) => addItem('additional_fees', $event)"
                  @add-item="addItem('additional_fees')"
                  @remove-item="removeItem('additional_fees', $event)"
              ></purchase-order-additional-item-modal>
            </div>
          </template>
          <div v-if="undeletedItems('additional_fees').length" class="row">
            <template
                v-for="(additional_item, key) in undeletedItems(
                'additional_fees'
              )"
            >
              <template v-if="additional_item._action !== 'delete'">
                <div
                    :key="`additional_fees.key.${key}`"
                    :class="`row  col-md-4`"
                >
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('additional_fees.total'))"
                      :vid="`additional_fees.${key}.total`"
                      class="col-md-12"
                      rules="required|gt:0"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst(additional_item['name'])}`"
                        :state="errors[0] ? false : validated ? true : null"
                    >
                      <numeral-input
                          :id="`${_uid}-value`"
                          v-model="additional_item['total']"
                          :name="`additional_fees[${key}][total]`"
                          :placeholder="lodash.upperFirst('Ex: 1000')"
                          :state="errors[0] ? false : validated ? true : null"
                          format="$ 0,0.[00]"
                          lazy-formatter
                          required
                          style="text-align: right"
                          @blur="onChangeAdditionalFeeTotal"
                      />
                    </b-form-group>
                    <div :key="`additional_fees.key.${key}.delete`" class="row">
                      <div class="col-sm delete-item">
                        <div class="float-end">
                          <b-button
                              class="button-remove-item"
                              size="sm"
                              tag="span"
                              variant="link"
                              @click="removeItem('additional_fees', key)"
                          >{{ $t("Delete") }}</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </validation-provider>
                </div>
              </template>
            </template>
          </div>
          <div v-else class="text-center empty-state">
            Belum ada biaya tambahan
          </div>
        </b-form-group>
        <hr/>
        <b-form-group
            :label="lodash.startCase($t('purchase_orders.discount'))"
            class="row mb-3"
            label-class="text-primary"
            label-cols-md="12"
        >
          <template #label>
            <div class="d-flex justify-content-between section-label">
              <div class="text-primary">
                {{ lodash.upperCase($t("purchase_orders.discount")) }}
              </div>
              <div>
                <b-button v-b-modal="`discounts-${_uid}`" variant="link-success"
                ><u class="text-success">Buat potongan biaya</u></b-button
                >
              </div>
              <purchase-order-additional-item-modal
                  :id="`discounts-${_uid}`"
                  modal-title="Buat potongan biaya"
                  nameLabel="Nama biaya"
                  totalLabel="Total biaya"
                  @ok="($event) => addItem('discounts', $event)"
                  @add-item="addItem('discounts')"
                  @remove-item="removeItem('discounts', $event)"
              ></purchase-order-additional-item-modal>
            </div>
          </template>
          <div v-if="undeletedItems('discounts').length" class="row">
            <template v-for="(discount, key) in undeletedItems('discounts')">
              <template v-if="discount._action !== 'delete'">
                <div :key="`discounts.key.${key}`" :class="`row  col-md-4`">
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('additional_fees.total'))"
                      :vid="`discounts.${key}.total`"
                      class="col-md-12"
                      rules="required|gt:0"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst(discount['name'])}`"
                        :state="errors[0] ? false : validated ? true : null"
                    >
                      <numeral-input
                          :id="`${_uid}-value`"
                          v-model="discount['total']"
                          :name="`discounts[${key}][total]`"
                          :placeholder="lodash.upperFirst('Ex: 1000')"
                          :state="errors[0] ? false : validated ? true : null"
                          format="$ 0,0.[00]"
                          lazy-formatter
                          required
                          style="text-align: right"
                          @blur="onChangeDiscountTotal"
                      />
                    </b-form-group>
                    <div :key="`discounts.key.${key}.delete`" class="row">
                      <div class="col-sm delete-item">
                        <div class="float-end">
                          <b-button
                              class="button-remove-item"
                              size="sm"
                              tag="span"
                              variant="link"
                              @click="removeItem('discounts', key)"
                          >{{ $t("Delete") }}</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </validation-provider>
                </div>
              </template>
            </template>
          </div>
          <div v-else class="text-center empty-state">
            Belum ada potongan biaya
          </div>
        </b-form-group>
        <hr/>
        <div class="row">
          <b-form-group
              :label="lodash.startCase($t('purchase_orders.total_biomassa'))"
              class="row mb-3 col-6"
              label-cols-md="12"
          >
            <b-input-group :append="$t('units.kg')">
              <numeral-input
                  :disabled="true"
                  :value="purchaseOrderTotalTonase"
                  name="total"
                  style="text-align: right"
              />
            </b-input-group>
          </b-form-group>
          <validation-provider
              v-slot="{ validated, errors }"
              :name="lodash.upperFirst($t('purchase_orders.total'))"
              :rules="totalPriceRules()"
              class="col-6"
              vid="total"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :label="lodash.startCase($t('purchase_orders.total_price'))"
                :state="errors[0] ? false : validated ? true : null"
                class="row mb-3"
                label-cols-md="12"
            >
              <b-input-group>
                <numeral-input
                    id="total"
                    v-model.number="model.total"
                    :disabled="true"
                    :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                    :state="errors[0] ? false : validated ? true : null"
                    format="$ 0,0.[00]"
                    name="total"
                    style="text-align: right"
                />
              </b-input-group>
            </b-form-group>
          </validation-provider>
        </div>
        <hr/>
      </span>
      <template v-if="model.shrimp_selected.code === 'harvest'">
        <b-form-group
            :label="lodash.startCase($t('operational_costs.singular'))"
            class="row mb-3"
            label-cols-md="12"
        >
          <template #label>
            <div class="d-flex justify-content-between section-label">
              <div class="text-primary">
                {{ lodash.upperCase($t("operational_costs.singular")) }}
              </div>
            </div>
          </template>
          <div class="row px-2">
            <div class="col-md-4 row g-2 mb-2">
              <validation-provider
                  v-slot="{ validated, errors }"
                  :name="lodash.upperFirst($t('purchase_orders.mark_up'))"
                  class="col-md-8"
                  rules="min_value:0"
                  vid="mark_up"
              >
                <b-form-group
                    :invalid-feedback="errors[0]"
                    :label="lodash.startCase($t('purchase_orders.mark_up'))"
                    :state="errors[0] ? false : validated ? true : null"
                >
                  <b-input-group
                      append="/kg"
                  >
                    <numeral-input
                        id="mark_up"
                        v-model.number="model.mark_up"
                        :placeholder="
                                        lodash.upperFirst($t('purchase_orders.mark_up'))
                                      "
                        :state="errors[0] ? false : validated ? true : null"
                        format="$ 0,0.[00]"
                        name="total"
                        style="text-align: right"
                    />
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </div>
          </div>
          <div class="row px-2">
            <div class="col-md-6 row mt-3">
              <b-table-simple borderless class="w-100">
                <b-thead>
                  <b-tr class="bg-slate-100 text-neutral-600">
                    <b-th>Glazing/Ice</b-th>
                    <b-th>Shipping</b-th>
                    <b-th>Labour</b-th>
                    <b-th>Total Biaya Operasional</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>{{ $numeral(costItem.ice).format("$ 0,0.[00]") }}</b-td>
                    <b-td>{{ $numeral(costItem.delivery).format("$ 0,0.[00]") }}</b-td>
                    <b-td>{{ $numeral(costItem.labour).format("$ 0,0.[00]") }}</b-td>
                    <b-td>{{ $numeral(model.total_operational_cost).format("$ 0,0.[00]") }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
        </b-form-group>
      </template>
      <div class="row">
        <div class="col-md-6">
          <validation-provider
              v-slot="{ validated, errors }"
              :name="lodash.upperFirst($t('models.description'))"
              rules="max:255"
              vid="description"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :label="lodash.upperFirst($t('models.description'))"
                :state="errors[0] ? false : validated ? true : null"
                class="row mb-3"
            >
              <editor
                  v-if="$parent.$parent.$options.name !== 'BModal'"
                  ref="editor"
                  v-model="model.description"
                  :init="editorInit"
                  class="form-control"
                  inline
                  plugins="lists link image paste help wordcount"
                  toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
              />
              <b-form-textarea v-else v-model="model.description"/>
            </b-form-group>
          </validation-provider>
        </div>
        <div class="col-md-6">
          <b-button v-if="bulkIndex > 0" v-b-modal="`modal-delete-${_uid}`" class="float-end" variant="outline-danger">
            Hapus Nota {{ bulkIndex + 1 }}
          </b-button>
        </div>
      </div>
    </div>
    <b-modal :id="`modal-delete-${_uid}`" hide-header>
      <template #default="{ hide }">
        <div class="custom-modal-body">Apakah anda ingin menghapus <b>Nota {{ bulkIndex + 1 }}</b>?</div>
      </template>

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button size="md" variant="danger" @click="$emit('delete', bulkIndex)">
          Ya, Hapus
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CustomerCreateModal from "@/components/modals/customer-create";
import FileDragAndDrop from "@/components/inputs/file-input";
import PurchaseOrderAdditionalItemModal from "@/components/modals/purchase-order-additional-item";
import ShrimpQualityModal from "@/components/modals/shrimp-quality-modal";
import Editor from '@tinymce/tinymce-vue';
import DatePicker from "@/components/inputs/datepicker";
import ManufactureSelectAjax from "@/components/inputs/manufacture-select-ajax.vue";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
import NumeralInput from '@/components/inputs/numeral';
import FileItem from '@/components/inputs/file-item';

export default {
  name: "purchase-order-create-form",
  components: {
    CustomerCreateModal,
    FileDragAndDrop,
    PurchaseOrderAdditionalItemModal,
    ShrimpQualityModal,
    DatePicker,
    ManufactureSelectAjax,
    MultiselectAjax,
    NumeralInput,
    Editor,
    FileItem,
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    bulkIndex: {
      type: Number,
      default: undefined,
    },
    isKmService: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      vendor_selection_options: [
        {text: "Tidak", value: "supplier"},
        {text: "Ya", value: "farmer"},
      ],
      editorInit: {
        height: 512,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: this.editorFilePickerCallback,
        mobile: {
          inline: true
        }
      },
      revert_ticket_id: null,
      file_accepts: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      init: true,
      selectedCustomerType: null,
      quality_options: [
        {value: 'fresh', text: 'Fresh'},
        {value: 'km', text: 'Kulit Muda (KM)'},
        {value: 'bs', text: 'Below Standard (BS)'},
        {value: 'us', text: 'Under Size (US)'},
        {value: 'merah', text: 'Merah'},
      ],
      fund_options: [
        {value: 'fresh', text: 'Fresh'},
        {value: 'kmtb', text: 'KMTB'}
      ],
      preview: '',
      firstFile: null,
      shrimp_selected: null,
      backupFile: {
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document) ? this.value.invoice_document : {name: 'invoice_document'},
        invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents) ? this.value.invoice_documents : [],
        operational_cost_documents: !this.lodash.isEmpty(this.value.operational_cost_document) ? this.value.operational_cost_document : {name: 'operational cost document'},
        operational_cost_document: !this.lodash.isEmpty(this.value.operational_cost_document) ? this.value.operational_cost_document : {name: 'operational cost document'},
        down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document) ? this.value.down_payment_document : {name: 'down payment document'},
      },
      model: {
        total: 0,
        service_fee: 0,
        customer_id: null,
        shrimp_id: null,
        farmer_id: null,
        farm_id: null,
        ordered_at: null,
        hatchery_id: null,
        shrimp_selected: null,
        down_payment: null,
        feed: null,
        mark_up: 0,
        total_operational_cost: 0,
        vendor_selection: "supplier",
        send_to_rfq: true,
        ...this.value,
        unit_duration: "days",
        ice_cost: this.value?.operational_costs?.find(({name}) => name.toLowerCase() === 'ice')?.total || 0,
        shipping_cost: this.value?.operational_costs?.find(({name}) => name.toLowerCase() === 'delivery')?.total || 0,
        labour_cost: this.value?.operational_costs?.find(({name}) => name.toLowerCase() === 'labour')?.total || 0,
        files: [
          ...((this.value.files || []).length ? this.value.files :
              [
                {name: 'invoice document'},
                {name: 'down payment document'},
                {name: 'operational cost document'}
              ]),
        ],
        purchase_items: [
          ...((this.value.purchase_items || []).length ? this.value.purchase_items : [{
            fund: 'fresh',
            quality: 'fresh',
          }]),
        ],
        purchase_additional_items: [
          ...((this.value.purchase_additional_items || []).length ? this.value.purchase_additional_items : []),
        ],
        additional_fees: [
          ...((this.value.purchase_additional_fees || []).length ? this.value.purchase_additional_fees : []),
        ],
        discounts: [
          ...((this.value.purchase_discounts || []).length ? this.value.purchase_discounts : []),
        ],
        operational_costs: [
          ...(this.value.operational_costs?.length ? this.value.operational_costs : [])
        ],
        other_operational_costs: [
          ...(
              this.value.operational_costs?.filter(({name}) => !['delivery', 'labour', 'ice'].includes(name.toLowerCase()))?.length ?
                  this.value.operational_costs?.filter(({name}) => !['delivery', 'labour', 'ice'].includes(name.toLowerCase())) : []
          )
        ],
        ticket: !this.lodash.isEmpty(this.value.ticket) ? this.value.ticket : {},
        ticketable: {
          ...(!this.lodash.isEmpty(this.value.ticketable) ? this.value.ticketable : {ticket_id: null})
        },
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document) ? this.value.invoice_document : {name: 'down payment document'},
        invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents) ? this.value.invoice_documents : [],
        invoice_document_files: [],
        operational_cost_document: !this.lodash.isEmpty(this.value.invoice_document) ? this.value.invoice_document : {name: 'operational cost document'},
        operational_cost_documents: !this.lodash.isEmpty(this.value.operational_cost_documents) ? this.value.operational_cost_documents : [],
        down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document) ? this.value.down_payment_document : {name: 'down payment document'},
        down_payment_documents: !this.lodash.isEmpty(this.value.down_payment_document) ? this.value.down_payment_documents : [{name: 'down payment document'}],
      },
      model_changed: false,
    }
  },
  watch: {
    'value': {
      handler: function (oldValue, newValue) {
        if (newValue) {
          // this.$set(this.model, 'duration', newValue.shrimp_selected?.duration || 0)
          this.$set(this.model, 'shrimp_id', newValue.shrimp_id)
          this.$set(this.model, 'shrimp_selected', newValue.shrimp_selected)
          this.$set(this.model, 'ticket', newValue.ticket)
        }
      },
      deep: true,
      immediate: true,
    },
    'model': {
      handler: function (oldValue, newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
    'model.mark_up': {
      immediate: true,
      handler: function () {
        this.calculateOperationalCostTotal();
      },
    },
    'model.purchase_items': {
      deep: true,
      immediate: true,
      handler: function () {
        this.calculateOperationalCostTotal();
      }
    },
  },
  computed: {
    dueDate() {
      if (!this.model.ordered_at) return '-'
      let dueDate = this.$moment(this.model.ordered_at, 'YYYY-MM-DD').add(this.model.duration > 0 ? this.model.duration : 0, this.model.unit_duration)
      return dueDate.format('D MMMM YYYY')
    },
    operationalDocumentState() {
      if (this.totalOperationalCost === 0) return true
      let filtered = [...this.model.operational_cost_documents.filter((value) => !this.lodash.isEmpty(value))]
      return filtered.length > 0
    },
    totalOperationalCost() {
      let otherCost = this.model.other_operational_costs.reduce((carry, {total}) => carry + total, 0)
      return this.model.ice_cost + this.model.labour_cost + this.model.shipping_cost + otherCost
    },
    totalQuantity() {
      return this.model.purchase_items.reduce((acc, curr) => ((curr.quantity || 0) + acc), 0)
    },
    costItem() {
      return {
        ice: (this.model.total_operational_cost ?? 0) * 0.1508,
        labour: (this.model.total_operational_cost ?? 0) * 0.3823,
        delivery: (this.model.total_operational_cost ?? 0) * 0.4669,
      }
    },
    isDownPaymentService() {
      return this.model.shrimp_selected.code === "down_payment";
    },
    downPaymentDisabledRules() {
      if (this.model.id) {
        if (this.model.payments.length > 0) {
          return true;
        }
      }
      return false;
    },
    shrimpDisabledRules() {
      if (!this.model.ticketable.ticket_id) return true;
      if (this.model.id && this.model.initial_shrimp_id === 13) {
        return false;
      }
      if (!this.model.id) {
        return false;
      }
      return true;
    },
    estimatedHarvestRules() {
      if (this.model.id) {
        const created_at = this.$moment(this.model.created_at).format(
            "YYYY-MM-DD"
        );
        return `required|after_or_equal:${created_at}`;
      }
      return `required|after_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
    },
    orderedAtRules() {
      if (this.model.shrimp_selected.code === 'down_payment') {
        return `required|after_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
      }
      return `required|before_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
    },
    shrimpCodeParams() {
      let param = {sort: "name,asc|is_beta,asc"};
      param.customer_type__contains = this.model.ticket.customer_type;
      param.is_active__eq = 1;
      return param;
    },
    priceRules() {
      return {
        required: true,
        gt: 0,
      }
    },
    purchaseAdditionalFeeTotal() {
      return this.model.additional_fees
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total || 0), 0);
    },
    purchaseDiscountTotal() {
      return -this.model.discounts
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total || 0), 0);
    },
    purchaseItemTotal() {
      return this.model.purchase_items
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total_price || 0), 0);
    },
    purchaseOrderSubTotal() {
      let iceCost = this.model.ice_cost || 0;
      let shippingCost = this.model.shipping_cost || 0;
      let labourCost = this.model.labour_cost || 0;
      let operationalCostTotal =
          iceCost +
          shippingCost +
          labourCost +
          this.model.other_operational_costs?.reduce(
              (carry, {total}) => carry + (total || 0),
              0
          );

      return this.purchaseOrderTotalPrice + operationalCostTotal;
    },
    purchaseOrderTotalPrice() {
      if (this.isDownPaymentService) return this.model.down_payment;

      let purchaseItemTotal = this.model.purchase_items
          .filter(({_action}) => _action !== "delete")
          .reduce(
              (carry, {quantity, unit_price}) =>
                  carry + (quantity || 0) * (unit_price || 0),
              0
          );
      let additionalFeeTotal = this.model.additional_fees
          .filter(({_action}) => _action !== "delete")
          .reduce((carry, {total}) => carry + (total || 0), 0);
      let discounts = this.model.discounts
          .filter(({_action}) => _action !== "delete")
          .reduce((carry, {total}) => carry + (total || 0), 0);

      return purchaseItemTotal + additionalFeeTotal - discounts;
    },
    purchaseOrderTotalTonase() {
      return this.model.purchase_items
          .filter((purchaseItem) => purchaseItem._action !== "delete")
          .reduce((total, v) => total + (v.quantity || 0), 0);
    },
    isKmServiceSelected() {
      return this.model.shrimp_selected.code === "deposit_goods";
    },
    ticketCustomerType() {
      return this.model?.ticket?.customer_type?.toLowerCase();
    },
    useDownPaymentProduct() {
      return this.model.shrimp_selected?.code === 'down_payment'
    },
  },
  methods: {
    calculateOperationalCostTotal() {
      if (this.model.shrimp_selected.code === 'harvest') {
        this.$set(this.model, 'total_operational_cost', this.model.mark_up * this.totalQuantity)
      }
    },
    onDeleteFile(file) {
      this.$set(this.model, file, {
        name: file,
        _action: "delete",
      });
    },
    removeFile(key, fileIndex) {
      const filteredFile = this.model?.[key].filter(
          (_, index) => index !== fileIndex
      );
      this.$set(this.model, key, filteredFile);
    },
    // eslint-disable-next-line no-unused-vars
    onTicketLoaded(event) {
      if (this.revert_ticket_id) {
        this.model.ticketable.ticket_id = this.revert_ticket_id;
      }
    },
    totalPriceRules() {
      return {
        required: true,
        gt: 0,
      };
    },
    checkLocalStorage() {
      let local = localStorage.getItem("purchase_order");
      if (local && !this.model.id) {
        let jsonData = JSON.parse(local);
        let vm = this;
        this.$set(this, "model", {
          total: 0,
          service_fee: 0,
          customer_id: null,
          shrimp_id: null,
          farmer_id: null,
          ordered_at: null,
          hatchery_id: null,
          shrimp_selected: null,
          down_payment: null,
          feed: null,
          ...jsonData,
          files: jsonData.files.map(function (item) {
            if (Object.keys(item).length)
              return {
                ...item,
                file: vm.dataURLtoFile(item.preview, item.name),
              };
            else return {...item};
          }),
          invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
              ? this.value.invoice_document
              : {name: "invoice_document"},
          invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
              ? this.value.invoice_documents
              : [],
          down_payment_document: !this.lodash.isEmpty(
              this.value.down_payment_document
          )
              ? this.value.down_payment_document
              : {name: "down payment document"},
          operational_cost_documents: !this.lodash.isEmpty(
              this.value.operational_cost_documents
          )
              ? this.value.operational_cost_documents
              : {name: "operational cost document"},
        });
      } else {
        // this.init = false
      }
    },
    updateLocalStorage() {
      let payload = {...this.model};
      if (this.model.ticket.customer_type === "lcs") {
        if (!this.model.id) {
          localStorage.setItem("purchase_orderx", JSON.stringify(payload));
        }
      } else {
        // localStorage.removeItem('purchase_order')
      }
    },
    onTicketSelected(event) {
      if (this.revert_ticket_id) {
        return null;
      }
      if (this.value.id && this.value.ticketable.ticket_id === event.id) {
        this.$set(this.model, "ticket", event);
        // this.updateLocalStorage()
        return null;
      } else {
        if (!this.init) {
          this.$set(this, "model", {
            total: 0,
            service_fee: 0,
            customer_id: null,
            shrimp_id: null,
            farmer_id: null,
            ordered_at: null,
            hatchery_id: null,
            shrimp_selected: null,
            down_payment: null,
            feed: null,
            unit_duration: "days",
            files: [{}],
            purchase_items: [
              {
                fund: "fresh",
                quality: "fresh",
              },
            ],
            purchase_additional_items: [{}],
            additional_fees: [],
            discounts: [],
            ticketable: {ticket_id: this.model.ticketable.ticket_id},
            ticket: {...event},
            invoice_document: {name: "invoice document"},
            invoice_documents: [],
            down_payment_document: {name: "down payment document"},
            operational_cost_document: {name: "operational cost document"},
            operational_cost_documents: [{name: "operational cost document"}],
          });
          this.updateLocalStorage();
        } else {
          this.$set(this.model, "ticket", event);
          // this.init = false
        }
      }
    },
    parterSelected(payload) {
      if (!this.lodash.isEmpty(payload)) {
        this.$set(
            this.model.payment,
            "from_bank_account_id",
            payload && payload?.id
        );
      } else {
        this.model.partner_id = null;
      }
    },
    addPurchaseItem() {
      let purchaseItem = {
        fund: "fresh",
        quality: "fresh",
      };
      if (this.model.shrimp_selected.code === "deposit_goods") purchaseItem.unit_price = 0;
      this.model.purchase_items.push(purchaseItem);
    },
    addOtherOperationalCost(val) {
      this.model.other_operational_costs?.push({...val});
    },
    removeOtherOperationalCost(index) {
      this.model.other_operational_costs?.splice(index, 1);
    },
    addItem(key, val) {
      this.model[key].push({
        ...val,
      });
      this.setPurchaseOrderTotal();
    },
    undeletedItems(key) {
      return this.model[key].filter((r) => r._action !== "delete");
    },
    removeItem(key, index) {
      const items = this.undeletedItems(key);
      if ((items[index] || {}).id) {
        items[index]._action = "delete";
      } else {
        items.splice(index, 1);
      }
      this.model[key] = items;
      this.setPurchaseOrderTotal();
    },
    dataURLtoFile(dataUrl, filename) {
      if (!dataUrl) return;
      let arr = dataUrl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    onChangeAdditionalFeeTotal() {
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onChangeDiscountTotal() {
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onFileChange(key, file) {
      let vm = this;
      let reader = new FileReader();
      let data = null;
      if (file instanceof File) {
        data = file;
      } else {
        file.target.files[0];
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key] = {...vm.backupFile[key]};
          return null;
        }, 1000);
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data);
        reader.onload = () => {
          this.$set(this.model[key], "preview", reader.result);
          this.$set(this.model[key], "extension", data.type);
          this.$set(this.backupFile, key, {...this.model[key]});
        };
      }
    },
    addFile(key, file, index) {
      this.model[key].push({});
      if (!index) {
        index = this.model[key].length - 1;
      }
      let vm = this;
      let reader = new FileReader();
      let data = null;
      if (file instanceof File) {
        data = file;
      } else {
        file.target.files[0];
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key][index] = {...vm.backupFile[key]};
          return null;
        }, 1000);
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data);
        reader.onload = () => {
          this.$set(this.model[key][index], "preview", reader.result);
          this.$set(this.model[key][index], "extension", data.type);
          this.$set(this.model[key][index], "file", data);
          this.$set(this.backupFile, key, {...this.model[key][index]});
        };
      }
    },
    onChangePurchaseItemQuantity(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem);
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onChangePurchaseItemUnitPrice(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem);
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onFundChange(fund, purchaseItemIndex) {
      if (fund === "kmtb") {
        this.model.purchase_items[purchaseItemIndex].unit_price = 0;
        this.model.purchase_items[purchaseItemIndex].total_price = 0;
      }
    },
    setPurchaseItemTotalPrice(purchaseItem) {
      this.$set(
          purchaseItem,
          "total_price",
          (purchaseItem.quantity || 0) * (purchaseItem.unit_price || 0)
      );
    },
    setPurchaseOrderTotal() {
      this.$set(
          this.model,
          "total",
          this.purchaseItemTotal +
          this.purchaseAdditionalFeeTotal +
          this.purchaseDiscountTotal || 0
      );
    },
    onFarmerSelected(event) {
      this.model.farmer = event
      if (event) {
        if (!this.model_changed) {
          this.model_changed = true;
        } else {
          this.model.farm_id = null;
        }
      } else {
        this.model.vendor_selection = 'supplier'
      }
    },
    farmerLabel(value) {
      const {code, name, region_full_name, phone_number} = value
      let additional = code
      if (region_full_name) additional = `${additional} - ${region_full_name}`
      if (phone_number) additional = `${additional} - ${phone_number}`

      return `${name} (${additional})`
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-item {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.empty-state {
  color: #acaebd;
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084f3;
}

.page-title {
  font-weight: 800;
  font-size: 12px;
  color: #6c7589;
}

.button-remove-item {
  color: #f14250 !important;
}
</style>
